export interface AdminConsoleConfig {
  isBeta: boolean;
  showBetaButton: boolean;
}

export type AdminConsoleTabId =
  | 'layers'
  | 'security-groups'
  | 'users'
  | 'card-types'
  | 'custom-details'
  | 'authentication'
  | 'link-to-custom-details'
  | 'custom-branding'
  | 'subscription'
  | 'positions'
  | 'company-configurations'
  | 'submit-time-configuration'
  | 'phases-manager'
  | 'report-configuration';

export interface AdminConsoleTab {
  id: AdminConsoleTabId;
  label: string;
}

export const ADMIN_CONSOLE_TABS: AdminConsoleTab[] = [
  { id: 'layers', label: 'Layers' },
  { id: 'security-groups', label: 'Security Groups' },
  { id: 'users', label: 'Users' },
  { id: 'card-types', label: 'Card Types' },
  { id: 'custom-details', label: 'Custom Details' },
  { id: 'authentication', label: 'Authentication' },
  { id: 'link-to-custom-details', label: 'Link to Custom Details' },
  { id: 'custom-branding', label: 'Custom Branding' },
  { id: 'subscription', label: 'Subscription' },
  { id: 'positions', label: 'Positions' },
  { id: 'company-configurations', label: 'Company Configurations' },
  { id: 'submit-time-configuration', label: 'Submit Time Configuration' },
  { id: 'phases-manager', label: 'Phases Manager' },
  { id: 'report-configuration', label: 'Report Configuration' },
];
